import ProductResults from "../../components/ProductResults"

const SearchPage = () => {


    
    return(
        <ProductResults />
    )
};


export default SearchPage;